export default "__VITE_ASSET__DhXBcbNV__"